enum Speed {
  UNSET_SPEED = 'UNSET_SPEED',  // Do not use, needed because of proto3 limitations
  SPEED_MAX = 'SPEED_MAX',
  SPEED_512KBPS = 'SPEED_512KBPS',
}

export { Speed as TrafficSpeed };
